import {HOME_DOI_PDF_NAME, HOME_DOI_PDF_PATH, productHelper, ProductsEnum, resourcesHelper} from "@falcon/services";
import * as React from "react";
import * as moment from "moment";
import {Link} from "react-router-dom";
import {getAmountWithDecimalDigits} from "../../CommonFunctions";
import {DocVersionEnum, getDocumentBrand, getDocumentVersionByDate} from "@falcon/plugin-falcon-journey";

interface IProps {
    unpaidChangeDueDate: string;
    interaction: any;
}

export class UnpaidChangeBanner extends React.Component<IProps> {
    private basePath = "/resources/documents/";
    private readonly version: DocVersionEnum;
    private readonly brand: string;
    private readonly isHome: boolean;

    constructor(props: IProps) {
        super(props);
        let startDateString = this.props.interaction.renewalDetails?.periodStartDate ?? this.props.interaction.factors.originalQuoteDate;
        let startDate = new Date(startDateString);

        this.version = getDocumentVersionByDate(startDate);
        this.brand = getDocumentBrand(this.version);
        this.isHome = productHelper.isHome(this.props.interaction);
    }

    getDOIPath(){
        return `${this.basePath}/LV_${this.brand}_Annual_Car/${this.version}/LV_${this.brand}_Annual_Car_DOI_${this.version}.pdf`
    }

    public render() {

        const { interaction, unpaidChangeDueDate } = this.props;

        if (interaction.paymentDetails?.submittedForSettlement) {
            // Payment was already processed. Without that condition banner is still present after payment, until customer relogin.
            return null;
        }

        const additionalPremium = interaction.factors.additionalPremium;
        const dueDate = moment.utc(unpaidChangeDueDate, moment.ISO_8601);
        const todayDate = moment.utc(moment().toDate(), moment.ISO_8601);
        const daysLeft = dueDate.diff(todayDate, 'days') + 1;

        return (
            <div className="inner-container">
                <div className="banner unpaid-changes-banner">
                    <div className="overflow-auto banner-content">
                        <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon" />
                        <div className="banner-text inline-warning-text">
                            Due to your recent claim and as per&nbsp;
                            {this.getDocumentOfInsurancePdfLink()}
                            &nbsp;there is an outstanding balance of&nbsp;
                            <span className="font-weight-bold">{getAmountWithDecimalDigits(additionalPremium)}</span>
                            &nbsp;left to pay. You have {daysLeft} days to make this payment or your {this.isHome ? "home" : "car"} insurance may be cancelled.
                        </div>
                    </div>
                    <div className="banner-action">
                        {this.getPaymentPageLink()}
                    </div>
                </div>
            </div>
        );
    }

    private getDocumentOfInsurancePdfLink(): JSX.Element {
        if (this.isHome) {
            return <React.Fragment>
            <a href={`${HOME_DOI_PDF_PATH}`} download={`${HOME_DOI_PDF_NAME}`}
               className="text-decoration-underline muli-bold-16-blue">T&Cs
            </a>
            </React.Fragment>
        } else {
            return <React.Fragment>
                <a href={`${this.getDOIPath()}`} download="Allianz Car Document of Insurance (DOI)"
                   className="text-decoration-underline muli-bold-16-blue">T&Cs
                </a>
            </React.Fragment>
        }
    }

    private getPaymentPageLink(): JSX.Element {
        const additionalPremium = this.props.interaction.factors.additionalPremium;
        const motorPaymentChoice = "/journey/init/product/AnnualMotorInsurance/process/mtaClaimImpact/presetPage/" + this.props.interaction._id;
        const homePaymentChoice = "/journey/init/product/AnnualHomeInsurance/process/mtaClaimImpact/presetPage/" + this.props.interaction._id;
        if (this.isHome) {
            return (
                <Link id="payNow" className="btn btn-primary btn-next-no-arrow mt-3 mb-0"
                      to={{
                          pathname: homePaymentChoice,
                          state: {
                              verifyCardFailed: false,
                              product: ProductsEnum.HOME
                          }
                      }}>
                    Pay {getAmountWithDecimalDigits(additionalPremium)} now
                </Link>
            )
        } else {
            return (
                <Link id="payNow" className="btn btn-primary btn-next-no-arrow mt-3 mb-0"
                      to={{
                          pathname: motorPaymentChoice,
                          state: {
                              verifyCardFailed: false,
                              product: ProductsEnum.WOLF_MOTOR
                          }
                      }}>
                    Pay {getAmountWithDecimalDigits(additionalPremium)} now
                </Link>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/UnpaidChangeBanner.tsx